import { asFunction } from "@/_di/resolvers";
import { AccreditationRepository } from "@/core/accreditation/domain/accreditationRepository";
import { apiAccreditationRepository } from "@/core/accreditation/infrastructure/apiAccreditationRepository";
import { accreditationUseCases, AccreditationUseCases } from "@/core/accreditation/useCases/accreditationUseCases";

export const accreditationModule = {
  accreditationRepository: asFunction<AccreditationRepository>(apiAccreditationRepository),
  accreditationUseCases: asFunction<AccreditationUseCases>(accreditationUseCases),
};
